import { render } from "./EcommercePro.vue?vue&type=template&id=5c0d7732&scoped=true"
import script from "./EcommercePro.vue?vue&type=script&lang=js"
export * from "./EcommercePro.vue?vue&type=script&lang=js"

import "./EcommercePro.vue?vue&type=style&index=0&id=5c0d7732&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0d7732"]])

export default __exports__